import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { CITIES } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#fdfaf7] border-t border-black/[0.06]">
      <div className="max-w-7xl mx-auto px-5 py-14">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          <div className="col-span-2">
            <div className="font-display text-2xl"><span className="text-[#1f1a1b]">Simply</span><span className="text-[#7c2233]">Sitter</span></div>
            <p className="mt-4 text-[15px] leading-relaxed max-w-xs text-[#5a5254]">Vetted childcare & household help across the United States.</p>
            <div className="mt-4 flex items-center gap-1.5 text-[14px] text-[#5a5254]"><Star className="w-4 h-4 text-[#7c2233] fill-[#7c2233]" /> Trusted by 8,500+ families</div>
          </div>

          <div>
            <h4 className="font-display text-[#1f1a1b] text-lg mb-3">Platform</h4>
            <ul className="space-y-2 text-[15px] text-[#5a5254]">
              <li><Link to="/for-families" className="hover:text-[#7c2233] transition-colors">For families</Link></li>
              <li><Link to="/for-caregivers" className="hover:text-[#7c2233] transition-colors">For caregivers</Link></li>
              <li><Link to="/jobs" className="hover:text-[#7c2233] transition-colors">Open jobs</Link></li>
              <li><Link to="/cities" className="hover:text-[#7c2233] transition-colors">Services</Link></li>
              <li><Link to="/how-it-works" className="hover:text-[#7c2233] transition-colors">How it works</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-[#1f1a1b] text-lg mb-3">Company</h4>
            <ul className="space-y-2 text-[15px] text-[#5a5254]">
              <li><Link to="/about" className="hover:text-[#7c2233] transition-colors">About us</Link></li>
              <li><Link to="/blog" className="hover:text-[#7c2233] transition-colors">Blog</Link></li>
              <li><Link to="/faq" className="hover:text-[#7c2233] transition-colors">FAQ</Link></li>
              <li><a href="mailto:hello@simplysitter.us" className="hover:text-[#7c2233] transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-[#1f1a1b] text-lg mb-3">Cities</h4>
            <ul className="space-y-2 text-[15px] text-[#5a5254]">
              {CITIES.slice(0, 8).map((c) => (
                <li key={c.slug}><Link to={`/city/${c.slug}`} className="hover:text-[#7c2233] transition-colors">{c.name}</Link></li>
              ))}
              <li><Link to="/cities" className="text-[#7c2233] hover:underline">Popular cities & services</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-[#1f1a1b] text-lg mb-3">Legal</h4>
            <ul className="space-y-2 text-[15px] text-[#5a5254]">
              <li><Link to="/privacy" className="hover:text-[#7c2233] transition-colors">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-[#7c2233] transition-colors">Terms</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-black/[0.08] flex flex-col sm:flex-row items-center justify-between gap-3 text-[13px] text-[#8a8285]">
          <span>© {new Date().getFullYear()} SimplySitter. All rights reserved.</span>
          <span>Made with care in the USA</span>
        </div>
      </div>
    </footer>
  );
}
